export default __webpack_public_path__ + "17b08dfab559c5930019bbe897c41f9d.png";